export default __webpack_public_path__ + "static/media/V385_CoC.863f9960.pdf";